<template>
  <b-container fluid class="py-5">
    <div class="py-5 d-flex align-items-center justify-content-center">
      <w-form @submit="submit">
        <template #submit="{ invalid }">
          <w-input v-model="id"></w-input>
          <button :disabled="invalid">login temp</button>
        </template>
      </w-form>
    </div>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      id: null,
    };
  },
  methods: {
    async submit() {
      const { id } = this;
      const data = await this.$wApi.user.test({ id });
      // console.log( "data", data );
      if( data.error ){
        window.alert("아이디를 확인해주세요.")
      }else{
        const { accessToken } = data;
        localStorage.setItem("m3dHubEditor__token", accessToken);
        const me = await this.$store.dispatch("getMe", this.$wApi);
        if (me) this.$router.push(this.$route.params.redirect || "/");      
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  button{
    background:#999DB6;
    width:100%;
    color:#fff;
    border-radius:5px;
    margin-top:10px;
    padding:10px 0;

  }
</style>
